import Clipboard from 'v-clipboard'
import VueTouchEvents from 'vue2-touch-events'
import autofocus from 'vue-autofocus-directive'
import VueAccount from 'app/plugins/account'
import VueProfile from 'app/plugins/profile'
import VueSubscription from 'app/plugins/subscription'
import VueValidations from 'app/plugins/validations'
import VueShortcuts from 'app/plugins/shortcuts'
import VueMarketing from 'app/plugins/marketing'
import VuePostHog from 'app/plugins/posthog'
import VueGrafanaFaro from 'app/plugins/grafanaFaro'
import store from 'app/store'
import VueApollo from 'vue-apollo'

export default (vueInstance) => {
  vueInstance.use(Clipboard)
  vueInstance.use(VueTouchEvents)
  vueInstance.use(VueAccount, { store })
  vueInstance.use(VueProfile, { store })
  vueInstance.use(VueSubscription, { store })
  vueInstance.use(VueValidations)
  vueInstance.use(VueShortcuts)
  vueInstance.use(VueMarketing)
  vueInstance.use(VuePostHog)
  vueInstance.use(VueGrafanaFaro)
  vueInstance.use(VueApollo)

  vueInstance.directive('autofocus', autofocus)
}
